module.exports = __webpack_public_path__ + "static/media/EditedPortfolioUXResearch.8b2c70eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/EditedPortfolioUXResearch.png
// module id = 44
// module chunks = 0